import { defineMessages } from 'react-intl';

export default defineMessages({
    reachedMaximumFieldLength: {
        id: 'nfum.platform.NfumInputField.reachedMaximumFieldLength',
        defaultMessage: 'You have reached maximum allowed field length'
    }
});
